import { useQuery } from "@apollo/client";
import type { Offering, OfferingsConnection } from "@casey/db-types";
import { GET_ORGANIZATION_OFFERINGS } from "../gql";

interface OrganizationOfferingsVariables {
  organizationId: string;
}

interface OrganizationOfferingsResponse {
  offerings: OfferingsConnection;
}

export function useOrganizationOfferings(organizationId: string) {
  const { data, loading, error, refetch } = useQuery<
    OrganizationOfferingsResponse,
    OrganizationOfferingsVariables
  >(GET_ORGANIZATION_OFFERINGS, {
    variables: { organizationId },
    skip: !organizationId,
    errorPolicy: "all",
  });

  return {
    offerings: data?.offerings?.nodes || [],
    loading,
    error,
    refetch,
  };
}

export type { Offering };
